export default __webpack_public_path__ + "static/media/admission-header.3627c386.jpg";